import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentDepartment } from "../departments/departmentsSlice";
import {
  cardsListOfADepartmentAsync,
  getQrCodePresignedUrlForDepartmentAsync,
  selectCardsListStatus,
  updateCardStatusForDepartmentAsync,
} from "../../home/cardsAndBadges/cards/cardsSlice";
import { SharedInterfaceCards } from "../../home/cardsAndBadges/cards/sharedInterface";
import { useNavigate, useParams } from "react-router-dom";
import {
  CardsListType,
  QrCodeInfo,
} from "../../home/cardsAndBadges/cards/cardsAPI";
import { CardSidePanel } from "../../home/cardsAndBadges/cards/sidePanel/CardSidePanel";

export const DepartmentCards = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const department = useAppSelector(selectCurrentDepartment);
  const cardsListStatus = useAppSelector(selectCardsListStatus);

  useEffect(() => {
    if (department && cardsListStatus === "idle") {
      void dispatch(cardsListOfADepartmentAsync(department.uuid));
    }
  }, [cardsListStatus, department, dispatch]);

  const sidePanelAction = useCallback(
    (props: Partial<CardsListType>) => {
      navigate(`/departments/cards/cards/${props.uuid}`);
    },
    [navigate],
  );

  const lockCardAction = useCallback(
    (isCardLocked: boolean, cardUuid: string) => {
      void dispatch(
        updateCardStatusForDepartmentAsync({
          cardUuid,
          status: isCardLocked ? "LOCKED" : "UNLOCKED",
        }),
      );
    },
    [dispatch],
  );

  const getQrCodePresignedUrlAction = useCallback(
    (qrCode: QrCodeInfo) => {
      void dispatch(getQrCodePresignedUrlForDepartmentAsync(qrCode));
    },
    [dispatch],
  );

  if (params.tab !== "cards") {
    return;
  }

  return (
    <SharedInterfaceCards
      sidePanelAction={sidePanelAction}
      sidePanel={
        <CardSidePanel
          lockCardAction={lockCardAction}
          getQrCodePresignedUrlAction={getQrCodePresignedUrlAction}
        />
      }
    />
  );
};
